// Keys stored in the Supabase `site_settings` table (key -> jsonb value)
export const SITE_SETTING_KEYS = {
  homeHeroImage: 'home_hero_image',
  homeHeroImages: 'home_hero_images',
  homeCtaImage: 'home_cta_image',
  homeAiPreviewImages: 'home_ai_preview_images',
  homeTestimonialAvatars: 'home_testimonial_avatars',
  productFinishingThumbnails: 'product_finishing_thumbnails',
  homeCategoryImages: 'home_category_images',
} as const;

export type SiteSettingKey = (typeof SITE_SETTING_KEYS)[keyof typeof SITE_SETTING_KEYS];

// id -> url map entries stored as JSON arrays inside `site_settings`
export interface IdUrlSetting {
  id: string;
  url: string;
}

// Metadata for admin-managed images (ids must stay stable)
export interface ManagedImageMeta {
  id: string;
  label: string;
}

export const TESTIMONIAL_AVATAR_META: ManagedImageMeta[] = [
  { id: 't1', label: '고객 후기 1' },
  { id: 't2', label: '고객 후기 2' },
];

export const HERO_IMAGE_META: ManagedImageMeta[] = [
  { id: 'h1', label: '히어로 이미지 1' },
  { id: 'h2', label: '히어로 이미지 2' },
  { id: 'h3', label: '히어로 이미지 3' },
  { id: 'h4', label: '히어로 이미지 4' },
];

export const FINISHING_THUMBNAIL_META: ManagedImageMeta[] = [
  { id: 'embossed', label: '엠보싱' },
  { id: 'foil', label: '형압 (금박)' },
  { id: 'uv', label: 'UV 코팅' },
  { id: 'diecut', label: '톰슨 (다이컷)' },
  { id: 'frosting', label: '프로스팅' },
];

export const CATEGORY_IMAGE_META: ManagedImageMeta[] = [
  { id: 'airless', label: '에어리스' },
  { id: 'pump', label: '펌프' },
  { id: 'spray', label: '스프레이' },
  { id: 'dropper', label: '드롭퍼' },
  { id: 'cream', label: '크림 단지' },
  { id: 'foam', label: '폼' },
  { id: 'tubes', label: '튜브' },
  { id: 'caps', label: '캡 & 마개' },
  { id: 'sample', label: '샘플' },
  { id: 'aluminum', label: '알루미늄' },
  { id: 'glass', label: '유리' },
  { id: 'pet', label: 'PET' },
  { id: 'cushion', label: '쿠션' },
  { id: 'lip', label: '립스틱' },
  { id: 'refill', label: '리필' },
  { id: 'eco', label: '친환경' },
];

export interface SiteSettingsState {
  homeHeroImage: string | null;
  homeHeroImages: Record<string, string>;
  homeCtaImage: string | null;
  homeAiPreviewImages: Record<string, string>;
  homeTestimonialAvatars: Record<string, string>;
  productFinishingThumbnails: Record<string, string>;
  homeCategoryImages: Record<string, string>;
}